export const buildUrl = (
  baseUrl: string,
  endpoint: string,
  params?: Record<string, unknown>
) => {
  const url = new URL(endpoint, baseUrl);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        url.searchParams.append(key, String(value));
      }
    });
  }

  return url.toString();
};
